// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__dCYQ6","error":"InputSecondary_error__3pWWm","disabled":"InputSecondary_disabled__dHXwU"};